import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import Navbar from './Navbar';
import Footer from './Footer';
import { API_URL } from '../config/api';

const DetailArticle = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState('');
  const [allImages, setAllImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleting, setDeleting] = useState(false);
const [showArchiveModal, setShowArchiveModal] = useState(false);
const [stats, setStats] = useState({ totalQuantity: 0, totalRevenue: 0, totalOrders: 0 });
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5; // nombre de commandes par page


// Découper les commandes pour la pagination
const indexOfLast = currentPage * itemsPerPage;
const indexOfFirst = indexOfLast - itemsPerPage;
const currentOrders = orders.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(orders.length / itemsPerPage);

  // const backendURL = 'http://localhost:8000';
  const backendURL = API_URL

useEffect(() => {
  const fetchProduct = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${backendURL}/products/${id}`);
      if (!res.ok) throw new Error('Erreur lors de la récupération du produit');
      const data = await res.json();
      setProduct(data);

      const imgs = [];
      if (data.img) imgs.push(data.img);
      if (Array.isArray(data.images))
        data.images.forEach(img => { if (img && img !== data.img) imgs.push(img); });

      setAllImages(imgs);
      setSelectedImage(imgs[0] || '');
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  fetchProduct();
  fetchProductOrders(); // 🔹 récupère aussi les commandes
}, [id]);

const fetchProductOrders = async () => {
  try {
    const res = await fetch(`${backendURL}/commandes/product/${id}`);
    if (!res.ok) {
      // Lire le texte de la réponse (HTML) pour debug
      const text = await res.text();
      console.error("Réponse non-JSON :", text.substring(0, 200));
      throw new Error(`HTTP ${res.status} - ${res.statusText}`);
    }
    const data = await res.json();
    setOrders(data.commandes || []);
    setStats(data.stats || { totalQuantity: 0, totalRevenue: 0, totalOrders: 0 });
  } catch (err) {
    console.error(err);
    alert("Impossible de récupérer les commandes associées. Vérifiez la route backend.");
  }
};

  const handleArchiveToggle = async () => {
  try {
    const endpoint = product.archived
      ? `${backendURL}/products/${product._id}/restore`
      : `${backendURL}/products/${product._id}/archive`;

    const res = await fetch(endpoint, {
      method: 'POST'
    });

    if (!res.ok) throw new Error("Action impossible");

    // Mise à jour locale sans recharger la page
    setProduct(prev => ({
      ...prev,
      archived: !prev.archived
    }));
  } catch (err) {
    console.error(err);
    alert("Erreur lors de l'opération");
  }
};

const handleDelete = async () => {
  try {
    setDeleting(true);
    const res = await fetch(`${backendURL}/products/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Suppression impossible');

    navigate('/articles');
  } catch (err) {
    console.error(err);
    alert('Erreur lors de la suppression');
  } finally {
    setDeleting(false);
    setShowDeleteModal(false);
  }
};

  const getImageUrl = img => (img?.startsWith('http') ? img : `${backendURL}/uploads/${img}`);

  if (loading) return <div className="loader">Chargement...</div>;
  if (!product) return <div>Aucun produit trouvé</div>;

  return (
    <div>
      <Navbar />

      <div className="detail-container">
        <div className="gallery-section">
          <div className="thumbnails">
            {allImages.map((img, i) => (
              <img key={i} src={getImageUrl(img)} alt={`Thumbnail ${i + 1}`} className={`thumbnail ${selectedImage === img ? 'active' : ''}`} onClick={() => setSelectedImage(img)} />
            ))}
          </div>

          <div className="main-image-container">
            {selectedImage && (
              <Zoom>
                <img src={getImageUrl(selectedImage)} alt={product.title} className="main-image" />
              </Zoom>
            )}
          </div>
        </div>

        <div className="info-section">
          <h1>{product.title}</h1>
          {product.archived && (
            <span className="badge-archived">ARCHIVÉ</span>
          )}
          <p className="description">{product.description}</p>
          <p><strong>Catégorie :</strong> {product.categorie}</p>
          <p><strong>Référence :</strong> {product.reference}</p>
          <p><strong>Marque :</strong> {product.label}</p>

         <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 10 }}>
  {/* Si promo > 0, on montre prix original barré + prix promo */}
  {product.promotion > 0 && product.prixOriginal > 0 ? (
    <>
      <span style={{ textDecoration: 'line-through', color: '#ff4d4f', fontWeight: 500 }}>
        {Number(product.prixOriginal).toLocaleString()} FCFA
      </span>
      <span style={{ color: '#e53935', fontWeight: 700 }}>
        Prix de vente : {Number(product.price).toLocaleString()} FCFA
      </span>
    </>
  ) : (
    // Sinon, on montre toujours le prix réel (prixOriginal)
    <span style={{ fontWeight: 600, fontSize: '1rem', color: '#333' }}>
       Prix de vente : {Number(product.prixOriginal > 0 ? product.prixOriginal : product.price).toLocaleString()} FCFA
    </span>
  )}
</div>

          <p><strong>Prix d'achat :</strong> {product.prixAchat?.toLocaleString() || 0} FCFA</p>
          <p><strong>Groupe :</strong> {product.groupe || 'N/A'}</p>
          <p><strong>Stock :</strong> {product.stock ?? 'N/A'}</p>
          <p><strong>Disponible :</strong> {product.disponible ? 'Oui' : 'Non'}</p>
          <p><strong>Nouveauté :</strong> {product.nouveaute ? 'Oui' : 'Non'}</p>
          <p><strong>Promotion :</strong> {product.promotion || 0} %</p>

     <div className="action-buttons">
  <Link to={`/modifierArticle/${product._id}`}>
    <button className="btn-primary action-btn">
      Modifier l'article
    </button>
  </Link>

<button
  className={`action-btn ${product.archived ? "btn-secondary" : "btn-warning"}`}
  onClick={() => setShowArchiveModal(true)}
>
  {product.archived ? "Restaurer l'article" : "Archiver l'article"}
</button>

  {/* <button
    className="btn-danger action-btn"
    onClick={() => setShowDeleteModal(true)}
  >
    Supprimer l'article
  </button> */}
</div>
        </div>

        <h2 style={{ marginTop: 40 }}>Commandes associées</h2>

{orders.length === 0 ? (
  <p>Aucune commande pour cet article.</p>
) : (
  <>
    <p>
      <strong>Total commandé :</strong> {stats.totalQuantity} unités &nbsp;|&nbsp;
      <strong>Chiffre d'affaires :</strong> {stats.totalRevenue.toLocaleString()} FCFA &nbsp;|&nbsp;
      <strong>Total commandes :</strong> {stats.totalOrders}
    </p>

    <table className="saas-table">
      <thead>
        <tr>
          <th>Numéro commande</th>
          <th>Client</th>
          <th>Quantité</th>
          <th>Total (FCFA)</th>
          <th>Statut</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {orders.map((order) => (
          <tr key={order._id}>
            <td>{order.numeroCommande || order._id}</td>
            <td>{order.client?.name || "N/A"}</td>
            <td>{order.cart?.reduce((acc, i) => acc + i.quantity, 0)}</td>
            <td>
              {order.cart?.reduce((acc, i) => acc + i.quantity * i.price, 0)?.toLocaleString()}
            </td>
            <td>{order.status}</td>
            <td>{new Date(order.createdAt).toLocaleDateString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {/* Pagination */}
    <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center', gap: 5 }}>
      <button
        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
      >
        Précédent
      </button>

      <span>
        Page {currentPage} / {totalPages}
      </span>

      <button
        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
      >
        Suivant
      </button>
    </div>
  </>

 
)}
      </div>

      {showDeleteModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h3>Confirmation de suppression</h3>
      <p>
        Voulez-vous vraiment supprimer cet article ?
        <br />
        <strong>Cette action est irréversible.</strong>
      </p>

      <div className="modal-actions">
        <button
          className="btn-secondary"
          onClick={() => setShowDeleteModal(false)}
          disabled={deleting}
        >
          Annuler
        </button>

        <button
          className="btn-danger"
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? 'Suppression...' : 'Oui, supprimer'}
        </button>
      </div>
    </div>
  </div>
)}

{showArchiveModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h3>{product.archived ? "Restaurer l'article" : "Archiver l'article"}</h3>
      <p>
        {product.archived
          ? "Voulez-vous vraiment restaurer cet article ? Il sera de nouveau disponible dans votre catalogue."
          : "Voulez-vous vraiment archiver cet article ? Il ne sera plus visible dans votre catalogue, mais pourra être restauré plus tard."}
      </p>

      <div className="modal-actions">
        <button
          className="btn-secondary"
          onClick={() => setShowArchiveModal(false)}
        >
          Annuler
        </button>

        <button
          className="btn-warning"
          onClick={async () => {
            setShowArchiveModal(false);
            await handleArchiveToggle();
          }}
        >
          {product.archived ? "Restaurer" : "Archiver"}
        </button>
      </div>
    </div>
  </div>
)}

      <Footer />
      <style>
        {
          `
          /* ================= MODAL CONFIRMATION ================= */
          .btn-danger{
          border-radius:0.7rem;
          }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-box {
  background: #fff;
  padding: 25px 30px;
  border-radius: 12px;
  width: 420px;
  max-width: 92%;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  animation: modalFade 0.25s ease-out;
}

.modal-box h3 {
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.modal-box p {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 25px;
}

/* Animation */
@keyframes modalFade {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
  .badge-archived {
  display: inline-block;
  margin-top: 6px;
  padding: 4px 10px;
  background: #ff4d4f;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 999px;
  letter-spacing: 0.5px;
}
  /* ================= ACTION BUTTONS ================= */
.action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 15px;
  flex-wrap: wrap; /* responsive */
}

.action-buttons a {
  text-decoration: none;
}

.action-btn {
  min-width: 180px;        /* 👈 même largeur */
  height: 44px;            /* 👈 même hauteur */
  padding: 0 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top:1rem
}

/* hover doux */
.action-btn:hover {
  transform: translateY(-1px);
  opacity: 0.95;
}
          `
        }
      </style>
    </div>
  );
};

export default DetailArticle;

